import React from 'react';
import { useKnowledgeUpload } from './hooks/useKnowledgeUpload';
import { UploadHeader } from './components/UploadHeader';
import { UploadForm } from './components/UploadForm';
import './KnowledgeUpload.css';

interface KnowledgeUploadProps {
  onCancel: () => void;
  onSuccess: () => void;
  targetOrgId?: string;
}

export function KnowledgeUpload({ onCancel, onSuccess, targetOrgId }: KnowledgeUploadProps) {
  const hookData = useKnowledgeUpload(targetOrgId, onSuccess);

  return (
    <div style={{ width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', paddingBottom: '40px' }}>
      <UploadHeader onCancel={onCancel} />
      <UploadForm hookData={hookData} onCancel={onCancel} />
    </div>
  );
}
